export default __webpack_public_path__ + "images/26_2_image.jpg";